import $ from 'jquery'

export default () => {

    const $mobileSlider = $('.js-mobile-slider');
    const $gallerySlider = $('.js-gallery-slider');
    const $cardCarousel = $('.js-card-carousel');
    const $timelineSlider = $('.js-timeline-slider');
    const $heroSlider = $('.js-slider-hero');
    const $heroSliderAutoplayDelay = $heroSlider.data("autoplaytimeout");
    const $slider = $('.js-slider');
    const $sliderTimeout = $('.js-slider-timeout');
    const $sliderAutoplayDelay = $sliderTimeout.data("slider-autoplaytimeout");
    const $tileSlider = $('.js-tile-slider');
    const $tileSliderBackground = $('.js-tile-slider-background');
    const $splitSlider = $('.js-split-slider');
    const $cardSlider = $('.js-card-slider');
    const $fullWidthSlider = $('.js-full-width-slider');
    const themeDefaults = {
        breakPoints : [320, 768, 1024, 1366]
    }
    const navArrows = [
        '<svg width="20" height="13" viewBox="0 0 20 13" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M6.35754 12.3072C6.74805 12.6977 7.38123 12.6977 7.77173 12.3072C8.16223 11.9167 8.16223 11.2835 7.77173 10.893L4.47876 7.60007L18.0646 7.60007C18.6168 7.60007 19.0646 7.15234 19.0646 6.60007C19.0646 6.04779 18.6168 5.60007 18.0646 5.60007L4.47876 5.60007L7.77173 2.30716C8.16223 1.91666 8.16223 1.28348 7.77173 0.892975C7.38123 0.502472 6.74805 0.502472 6.35754 0.892975L1.36426 5.88617C1.35974 5.89066 1.35522 5.89517 1.35071 5.89975L0.650391 6.60007L1.35071 7.30038C1.35522 7.30496 1.35974 7.30948 1.36426 7.31396L6.35754 12.3072Z"/> </svg>',
        '<svg width="20" height="13" viewBox="0 0 20 13" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M13.3574 0.893005C12.9669 0.502471 12.3337 0.502471 11.9432 0.893005C11.5527 1.28351 11.5527 1.91669 11.9432 2.30719L15.2362 5.6001L1.65039 5.6001C1.09815 5.6001 0.650391 6.04782 0.650391 6.6001C0.650391 7.15237 1.09814 7.6001 1.65039 7.6001L15.2362 7.6001L11.9432 10.893C11.5527 11.2835 11.5527 11.9167 11.9432 12.3072C12.3337 12.6977 12.9669 12.6977 13.3574 12.3072L18.3507 7.314C18.3552 7.30951 18.3597 7.30499 18.3643 7.30041L19.0646 6.6001L18.3643 5.89978C18.3597 5.8952 18.3552 5.89069 18.3507 5.8862L13.3574 0.893005Z"/> </svg>'
    ];

    $gallerySlider.owlCarousel({
        autoplay: false,
        nav: true,
        navText: false,
        items: 2,
        margin: 15,
        dots: false,
        responsive: {
            1024: {
                items: 4,
                margin: 20
            }
        }
    });

    $.map( $cardCarousel, function( sliderObj ) {
        const $navContainer = $(sliderObj).parent().find('.js-card-carousel-nav');
        const $dotsContainer = $(sliderObj).parent().find('.js-card-carousel-dots');

        $(sliderObj).owlCarousel({
            stagePadding: 15,
            autoplay: false,
            nav: true,
            navText: navArrows,
            navContainer: $navContainer,
            dots: true,
            dotsContainer: $dotsContainer,
            dotsEach: 1,
            items: 1,
            margin: 15,
            slideTransition : 'cubic-bezier(.64,.07,.7,.65)',
            responsive: {
                768: {
                    items: 2,
                    margin: 20,
                },
                1366: {
                    items: 3,
                    margin: 20,
                }
            }
        });
    });

    $.map( $timelineSlider, function( sliderObj ) {
        $(sliderObj).owlCarousel({
            stagePadding: 0,
            center: true,
            autoplay: false,
            nav: true,
            navText: navArrows,
            navContainer: $(sliderObj).parent().find('.js-timeline-slider-nav'),
            dots: false,
            loop: true,
            items: 1,
            margin: 15,
            responsive: {
                1100: {
                    stagePadding: 120,
                },
                1200: {
                    stagePadding: 150,
                },
                1420: {
                    stagePadding: 200,
                },
                1580: {
                    stagePadding: 120,
                    center: false
                }
            }
        });
    });

    $heroSlider.owlCarousel({
        loop: true,
        autoplay: true,
        autoplayTimeout: $heroSliderAutoplayDelay,
        autoplayHoverPause: true,
        autoHeight: true,
        nav: false,
        items: 1,
        animateOut: 'fadeOut',
        mouseDrag: false,
        pullDrag: false,
        touchDrag: false,
        dotsContainer: $('.js-slider-hero-dots')
    });

    let $sliderAutoplay = false

    if ($sliderTimeout.length){
        $sliderAutoplay = true
    } else {
        $sliderAutoplay = false
    }

    $.map( $slider, function( sliderObj ) {
        const checkSiblings = $(sliderObj).siblings('.js-slider-dots');
        const checkNext = $(sliderObj).next('.wrap').find('.js-slider-dots');
        const $dotsContainer = checkSiblings.length > 0 ? checkSiblings : checkNext;

        $(sliderObj).owlCarousel({
            loop: true,
            autoplay: $sliderAutoplay,
            autoplayTimeout: $sliderAutoplayDelay,
            autoplayHoverPause: true,
            autoHeight: true,
            items: 1,
            nav: true,
            navElement: `button type="button"`,
            animateOut: 'fadeOut',
            dotsContainer: $dotsContainer,
            onInitialized: function() {
                // Accessibility fix to add labels to dot buttons
                $dotsContainer.find('.owl-dot').each(function() {
                    $(this).attr('aria-label', `Go to slide ${$(this).index() + 1}`);
                });

                // Accessibility fix to move labels to nav buttons
                $(sliderObj).find('.owl-nav span').each(function() {
                    const ariaLabel = $(this).attr('aria-label');
                    $(this).parent().attr('aria-label', ariaLabel);
                    $(this).attr('aria-label', '');
                });
            }
        });
    });
    
    $tileSlider.on('initialized.owl.carousel', function() {
        const $slides = $tileSlider.find('.js-tile-slide');
        $slides.on('mouseenter', function () {
            if ($(window).width() >= 768) {
                setActiveTileSlide($(this));
            }
        });
    });

    $tileSlider.on('changed.owl.carousel', function(e) {
        const $slides = $tileSlider.find('.js-tile-slide');
        setActiveTileSlide($slides.eq(e.item.index));
    });

    $tileSlider.owlCarousel({
        loop: true,
        autoplay: true,
        autoplayHoverPause: true,
        nav: true,
        navText: false,
        items: 1,
        margin: 0,
        dots: false,
        responsive: {
            768: {
                items: 2,
            },
            1024: {
                items: 4,
            }
        }
    });

    $.map($splitSlider, function(splitSliderObj) {
        const $el = $(splitSliderObj);
        const totalItems = $el.children().length;

        $el.owlCarousel({
            loop: true,
            autoplay: false,
            autoplayHoverPause: false,
            nav: true,
            navText: false,
            items: 1,
            margin: 0,
            dots: true,
            dotsContainer: $el.siblings('.js-slider-dots'),

            onInitialized: function() {
                // only fix when exactly 2 slides
                if (totalItems === 2) {
                    setTimeout(function() {
                        $el.trigger('refresh.owl.carousel');
                    }, 50);
                }
            }
        });

        // also guard the window load refresh
        if (totalItems === 2) {
            $(window).on('load', function() {
                $el.trigger('refresh.owl.carousel');
            });
        }
    });

    $.map( $cardSlider, function( sliderObj ) {
        const $navContainer = $(sliderObj).parent().find('.js-card-slider-nav');
        const $dotsContainer = $(sliderObj).parent().find('.js-card-slider-dots');

        $(sliderObj).owlCarousel({
            loop: true,
            autoplay: false,
            autoplayHoverPause: false,
            items: 1,
            margin: 10,
            nav: true,
            navText: navArrows,
            navContainer: $navContainer,
            dots: true,
            dotsContainer: $dotsContainer,
            responsive : {
                768 : {
                    margin: 30,
                }
            }
        });
    });

    $.map( $fullWidthSlider, function( sliderObj ) {
        const $navContainer = $(sliderObj).parent().find('.js-full-width-slider-nav');
        const $dotsContainer = $(sliderObj).parent().find('.js-full-width-slider-dots');
        const $slides = $(sliderObj).children();

        $(sliderObj).owlCarousel({
            autoHeight: true,
            items: 1,
            nav: true,
            navText: navArrows,
            navContainer: $navContainer,
            dots: true,
            dotsContainer: $dotsContainer,
            animateOut: 'fadeOut'
        });

        $(sliderObj).on('changed.owl.carousel', function(e) {
            const $activeSlide = $slides.eq(e.item.index);
            $(sliderObj).parent().attr('data-colour', $activeSlide.first().data('colour'));
        });
    });

    $(window).on("resize", function () {
        if ( $(window).width() < 1024 ) {
            startCarousel()
        } else {
            stopCarousel()
        }
    }).resize()

    function startCarousel(){
        $mobileSlider.owlCarousel({
            stagePadding: 30,
            navigation: false,
            slideSpeed: 500,
            margin: 10,
            paginationSpeed: 400,
            autoplay: false,
            items: 1,
            itemsDesktop: false,
            itemsDesktopSmall: false,
            itemsTablet: false,
            itemsMobile: false,
            loop: false,
            nav: true,
            responsive : {
                650 : {
                    stagePadding: 30,
                    items: 2,
                }
            }
        });
    }

    function stopCarousel() {
        $mobileSlider.trigger('destroy.owl.carousel');
        $mobileSlider.addClass('off');
    }

    function setActiveTileSlide($el) {
        const currentActive = $tileSliderBackground.find('img.is-active');
        const newActive = $tileSliderBackground.find('img').eq($el.data('background') - 1);
        if (currentActive !== newActive) {
            currentActive.removeClass('is-active');
            newActive.addClass('is-active');
        }
        const $slides = $tileSlider.find('.js-tile-slide');
        $slides.not($el).each(function() {
            $(this).removeClass('is-active');
        });
        $el.addClass('is-active');
    }

    /**
     * This effectively makes used of 'vw' but because Windows doesn't
     * distinguish difference between window width when a scrollbar is or isn't present
     * 100vw ends up as the same number regardless, which causes a slight overflow.
     */

    if (window.innerWidth >= themeDefaults.breakPoints[2]) {
        $(window).on('load resize', function() {
            const $contentWrapStretch = $('.content-wrap-stretch')

            if($contentWrapStretch) {
                $contentWrapStretch.width(
                    `calc(50% + ${$('body').width() / 2}px)`
                )
            }
        })
    }

    if (window.innerWidth <= themeDefaults.breakPoints[2]) {
        $(window).on('load resize', function() {
            const $sliderTimeline = $('.slider-timeline')

            if ($sliderTimeline) {
                $sliderTimeline.width(
                    `${$('body').width()}px`
                )
            }
        })
    } else if (window.innerWidth > themeDefaults.breakPoints[2]) {
        $(window).on('load resize', function() {
            const $sliderTimeline = $('.slider-timeline:not(.slider-timeline--sidebar)')
            const $sliderTimelineSidebar = $('.slider-timeline--sidebar')

            if ($sliderTimeline) {
                $sliderTimeline.width(
                    `${$('body').width()}px`
                )
            }

            if ($sliderTimelineSidebar) {
                $sliderTimelineSidebar.width(
                    `calc(25% + ${$('body').width() / 2}px)`
                )
            }
        })
    }
}
